export const max_refresh_time = 60000;
// export const paymentAddress = process.env.REACT_APP_PAYMENT_ADDRESS;
// export const csrAddress = process.env.REACT_APP_CSR_ADDRESS;
export const version = 'v0';
// const serverAddress = domain ? 'https://api-dev.reachmobileplatform.com' : 'https://api-dev.reachmobile.com/v0';
// const serverAddress = process.env.REACT_APP_SERVER_ADDRESS;
//export const domain = process.env.DOMAIN_BOOLEAN; // true=== earthlink amd false=== reach mobile
// export const serverAddressDev = 'https://api-dev.reachmobile.com/v0';
export const domain = false;

//domainName should be same as one of the key-value from domainMap.
// in domainMap T1 corresponds to REACH (sim) while T2 to corresponds to EL (fixed-wireless)
// naming can be any to make it not associated with a particular brand. (just that domainName should be present in domainMap)
export const domainName = 'TEMP1';
export const domainMap = {
    T1: 'TEMP1', //TMO
    T2: 'TEMP2', //EL
    T3: 'TEMP3', //NL
};
export const isPaymentEnabled = process.env.REACT_APP_PAYMENT_ENABLED === 'true';
export const isAstoundSSO = process.env.REACT_APP_ASTOUND_SSO_LOGIN === 'true';

export const tokenExpireTime = 60 * 60 * 12;
// export const reachCarrierId = 'e9f52be5-60e1-4b68-837e-b54108c65c63';
// export default serverAddress;
export const shippingData = {
    carrierCode: 'stamps_com',
    serviceCode: 'usps_first_class_mail',
    serviceType: 'USPS First Class Mail',
    reachCarrierId: 'e9f52be5-60e1-4b68-837e-b54108c65c63',
};

export const configPayload = {
    configId: "PROV_CONFIG",
    configKeys: "ENABLE_FLAT_REFERRAL,REFERRER_DISC_IN_DOLLAR,REFEREE_DISC_IN_DOLLAR,DELAY_REFERRAL_COUPON_BY_MONTHS,AUTO_TOP_UP_SIZE,AUTO_TOP_UP_AMOUNT,PRORATE_DATA_MIN_LIMIT_MB,STANDARD_BILL_DAY,ENABLE_DATA_PRORATE,IR_MIN_CREDIT_AMOUNT,IR_PAYGO_CREDIT_LIMIT,IR_MIN_COVER_CREDIT_AMOUNT,IR_MAX_CREDIT_AMOUNT,IR_INCR_CREDIT_AMOUNT,BILL_DUE_DAYS",
    topupPulseDetails: true,
    mvne: "TMOBILE",
}

export const isHSDEnabled = true;

export const maxLength = 64;

export const LOGIN_PROVIDER = {
    FIREBASE : 'firebase',
    SSO : 'sso',
  }